import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EstablishmentService } from '../../establishment.service';
import { DefaultSupervisionScopeEnum } from '../../../../../../core/models/default-supervision.model';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';

/**
 * Onglet « Supervision métier » de la fiche établissement (PRED-3061) :
 * configuration prioritaire sur celle du tenant, avec indication visuelle
 * des acteurs hérités de la configuration client.
 */
@Component({
  selector: 'vex-establishment-details-supervision',
  template: `
    <default-supervision-tree
      *ngIf="establishment"
      [scope]="scope"
      [establishment]="establishment"
      [modifyPermissions]="modifyPermissions"
    ></default-supervision-tree>
  `,
})
export class EstablishmentDetailsSupervisionComponent implements OnInit, OnDestroy {
  scope = DefaultSupervisionScopeEnum.ESTABLISHMENT;
  modifyPermissions = [ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT];
  establishment: { _id: string; label: string; technicalIdentifier?: string };

  private subscription = new Subscription();

  constructor(private establishmentService: EstablishmentService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.establishmentService.entity$.subscribe(entity => {
        if (entity?._id) {
          this.establishment = {
            _id: entity._id,
            label: entity.label,
            technicalIdentifier: entity.technicalIdentifier,
          };
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
